import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-evaluation-cities',
  templateUrl: './evaluation-cities.component.html',
  styleUrls: ['./evaluation-cities.component.scss']
})
export class EvaluationCitiesComponent implements OnInit {
  public cities = [];
  
  constructor(private req: HttpRequestsService<any>,private router: Router) { }

  ngOnInit(): void {
    this.req.getCities().subscribe((res) => this.cities = res);
  }

  onCity(city) {
    this.router.navigateByUrl(`${city.City}/Evaluation`, {state:{city:city.City, country: city.Country, code:city.Code, description: city.Description, email: city.Email, video: city.Video}});
  }

  goToActions() {
    this.router.navigate(['City-Innovative-Actions'])
  }
}
